<template>
  <div>
    <page-title
      icon="fa fa-shopping-cart"
      main="Pedidos"
      sub="Pedidos"
      :help="true"
      titleHelp="Ajuda - Pedidos"
      content="Responsável por listar e cadastrar Pedidos permitindo filtros por Cliente e Status do Pedido.
Para criação de um pedido pressione o botão no canto superior direito 'Cadastro de Pedido'.
Para alteração de uma Campanha basta ir com o mouse em ações e clicar em Editar."
    >
      <template v-slot:actions>
        <base-button @click="register" type="neutral" class="ml-3" size="sm"
          >Cadastro de Pedido</base-button
        >
      </template>
    </page-title>

    <modal :mouseDownOn="false" :show.sync="modals.modal0" id="cadastrar-seções" size="lg" >
      <template slot="header">
        <h5 class="modal-title ml-4" id="exampleModalLabel">
          {{ purchase_order && purchase_order.id ? "Editar Pedido" : "Cadastrar Pedido" }}
        </h5>
      </template>
      <collapse :multiple-active="multipleActive" :active-index="c_active_index" class="mt--5">
      <!-- Header Purchase Order -->
        <collapse-item :title="orderCollapsibleTitle()" wrapperClasses="">
          <validation-observer ref="observer">
            <form role="form">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label d-block">Data de Emissão</label>
                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        :config="{
                          allowInput: true,
                          locale: 'pt',
                          altInput: true,
                          altFormat: 'd/m/Y',
                        }"
                        class="form-control datepicker"
                        v-model="purchase_order.issue_date"
                        placeholder="Data de Emissão"
                        :required="true"
                      />
                    </base-input>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label  d-block">Data de Vencimento</label>
                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        :config="{
                          allowInput: true,
                          locale: 'pt',
                          altInput: true,
                          altFormat: 'd/m/Y',
                        }"
                        class="form-control datepicker"
                        v-model="purchase_order.due_date"
                        placeholder="Data de Vencimento"
                        :required="true"
                      />
                    </base-input>
                  </div>
                  <div
                    v-if="!validField(purchase_order.due_date)"
                      class="invalid-feedback"
                      style="display: block;"
                  >
                    Campo obrigatório
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-control-label">Cliente <span class="text-danger">*</span></label>
                    <multiselect
                      v-model="purchaseOrderClient"
                      class="select-client"
                      :options="clients"
                      placeholder="Selecionar Cliente"
                      :loading="isLoadingClient"
                      label="razao_social"
                      track-by="id"
                      :internal-search="false"
                      @search-change="debouncedSetClients"
                      @input="
                        validateClientForPurchase();
                        updateClientInfo();
                        resetProperty();
                      "
                    >
                      <template slot="option" slot-scope="props">
                        <div class="option__desc"><span class="option__title" style="font-size: 12px;">{{ props.option.code }} - {{ props.option.razao_social }}</span></div>
                      </template>
                      <template slot="singleLabel" slot-scope="props">
                        <span class="multiselect__single" style="font-size: 12px;">{{ props.option.code }}  {{ props.option.razao_social }}</span>
                      </template>
                    </multiselect>
                    <div
                      v-if="!validField(purchase_order.client)"
                      class="invalid-feedback"
                      style="display: block;"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-12"
                  v-if="client.client_properties.length == 0"
                >
                  <base-input
                    v-model="purchaseOrderClientInfo.delivery_address"
                    placeholder="Endereço"
                    label="Local de Entrega"
                    autocomplete="off"
                    :required="true"
                  >
                    <template v-slot:error>
                      <div
                        v-if="!validField(purchaseOrderClientInfo.delivery_address)"
                        class="invalid-feedback"
                        style="display: block;"
                      >
                        Campo obrigatório
                      </div>
                    </template>
                  </base-input>
                </div>
                <div class="col-md-12" v-else>
                  <div class="form-group">
                    <label class="form-control-label">Propriedade <span class="text-danger">*</span></label>
                    <multiselect
                      v-model="clientProperty"
                      :options="filteredClientProperties"
                      placeholder="Selecionar Propriedade"
                      :required="true"
                      label="endereco"
                      track-by="id"
                      @click="updateClientInfo"
                      @input="
                        purchaseOrderClientInfo.delivery_address = clientProperty.endereco;
                        purchaseOrderClientInfo.propried_id = clientProperty.id;
                      "
                    />
                    <div
                      v-if="!validField(clientProperty)"
                      class="invalid-feedback"
                      style="display: block;"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label">Email <span class="text-danger">*</span></label>
                  <base-input
                    v-model="purchaseOrderClientInfo.email"
                    placeholder="Email do Cliente"
                    class="input-email"
                  >
                    <template v-slot:error>
                      <div
                        v-if="!validField(purchaseOrderClientInfo.email)"
                        class="invalid-feedback"
                        style="display: block;"
                      >
                        Campo obrigatório
                      </div>
                    </template>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">Empresa <span class="text-danger">*</span></label>
                    <multiselect
                      v-model="purchase_order.enterprises"
                      :options="filteredEnterprises"
                      placeholder="Selecionar Empresa"
                      :disabled="!!purchase_order.id"
                      :loading="isLoadingEnterprise"
                      label="iden_emp"
                      :internal-search="false"
                      track-by="codi_emp"
                      @input="
                        initStocks();
                        setClientSalesman();
                      "
                      @search-change="filterEnterprises"
                    >
                      <template slot="option" slot-scope="props">
                        <div class="option__desc"><span class="option__title">{{ props.option.codi_emp }} - {{ props.option.iden_emp }}</span></div>
                      </template>
                      <template slot="singleLabel" slot-scope="props">
                        <span class="multiselect__single">{{ props.option.codi_emp }} - {{ props.option.iden_emp }}</span>
                      </template>
                    </multiselect>
                    <div
                      v-if="!validField(purchase_order.enterprises)"
                      class="invalid-feedback"
                      style="display: block;"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">Tipos de operação</label>
                    <multiselect
                      v-model="purchase_order.operation_type"
                      :options="filteredOperationTypes"
                      placeholder="Selecionar Tipo de operação"
                      label="desc_top"
                      :select-label="''"
                      :deselect-label="''"
                      :selected-label="'Selecionado'"
                      track-by="codi_top"
                      :internal-search="false"
                      @input="handleOperationSelection"
                      @search-change="filterOperationType"
                    >
                      <template slot="option" slot-scope="props">
                        <div class="option__desc"><span class="option__title">{{ props.option.codi_top }} - {{ props.option.desc_top }}</span></div>
                      </template>
                      <template slot="singleLabel" slot-scope="props">
                        <span class="multiselect__single">{{ props.option.codi_top }} - {{ props.option.desc_top }}</span>
                      </template>
                    </multiselect>
                    <div
                      v-if="!validField(purchase_order.operation_type)"
                      class="invalid-feedback"
                      style="display: block;"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label"
                      >Condição de Pagamento</label
                    >
                    <multiselect
                      v-model="purchase_order.payment_type"
                      :options="filteredPaymentTypes"
                      placeholder="Selecionar Condição"
                      label="name"
                      track-by="id"
                      :select-label="''"
                      :deselect-label="''"
                      :selected-label="'Selecionado'"
                      :internal-search="false"
                      :loading="isLoadingPayment"
                      @input="changePayment($event)"
                      @search-change="filterPaymentType"/>
                    <div
                      v-if="!validField(purchase_order.payment_type)"
                      class="invalid-feedback"
                      style="display: block;"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">Descontos</label>
                    <multiselect
                      v-model="purchase_order.discount"
                      :options="discounts"
                      placeholder="Selecionar Desconto"
                      label="name"
                      track-by="id"
                      :select-label="''"
                      :deselect-label="''"
                      :selected-label="'Selecionado'"
                      :loading="isLoadingDiscount"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">Forma de Pagamento</label>
                    <multiselect
                      v-model="purchase_order.payment_form"
                      :options="filteredFormOfPayments"
                      placeholder="Selecionar Forma de Pagamento"
                      :select-label="''"
                      :deselect-label="''"
                      :selected-label="'Selecionado'"
                      :required="true"
                      label="description"
                      track-by="id"
                    />
                    <div
                      v-if="!validField(purchase_order.payment_form)"
                      class="invalid-feedback"
                      style="display: block;"
                    >
                      Campo obrigatório
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label">Vendedor</label>
                    <multiselect
                      v-model="purchase_order.user"
                      :options="salesmans"
                      placeholder="Selecionar Vendedor"
                      :select-label="''"
                      :deselect-label="''"
                      :selected-label="'Selecionado'"
                      :required="true"
                      label="name"
                      track-by="id"
                      @search-change='setSalesmans'
                      :disabled="
                        !(
                          currentUser.is_admin ||
                          currentUser.is_manager ||
                          currentUser.has_coordinateds
                        )
                      "
                    />
                    <div
                      v-if="isLoadingSalesmanErpValidation"
                      style="display: block;"
                    >
                      <div class="valid-feedback" style="display: flex; align-content: center;">
                        <span>Validando presença de vendedor no ERP </span>
                        <div style="transform: scale(0.5);width:10px;display: inline flow-root;" v-loading="true"> </div>
                      </div>
                    </div>

                    <div
                      v-else-if="salesmanPurchaseValidations.erpValidation && purchase_order.user.id"
                      class="invalid-feedback"
                      style="display: block;"
                    >
                      {{salesmanPurchaseValidations.erpValidation}}
                    </div>

                    <div
                      v-else-if="!validField(purchase_order.user)"
                      class="invalid-feedback"
                      style="display: block;"
                    >
                      Campo obrigatório
                    </div>

                    <div
                      v-else-if="purchase_order.user && purchase_order.user.id" class="valid-feedback"
                      style="display: block;"
                    >
                      Vendedor consta no ERP
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </validation-observer>
          <base-button type="success" @click="addOrderItem" id="add-products">Adicionar Produtos</base-button>
        </collapse-item>

        <!-- Order Items -->
        <collapse-item
          v-for="(order_item, index) in purchase_order.order_items"
          :key="(index + 1)"
          :title="collapsibleTitle(order_item, index)"
          wrapperClasses=""
        >
          <!-- Actions -->
          <template v-if="purchase_order && !purchase_order.id" v-slot:actions>
            <base-button icon type="warning" v-on:click="removeOrderItem(index)" size="sm">
              <span class="btn-inner--icon">
                <i class="fa fa-trash"></i>
              </span>
              <span class="btn-inner--text">Remover</span>
            </base-button>
          </template>

          <!-- Content -->
          <validation-observer ref="product_observer">
            <form role="form">
              <div class="row">
                <div class="col-12">
                  <order-item-form
                    :purchase-order="purchase_order"
                    :stocks="stocks"
                    :order-item.sync="order_item"
                    @update:order-item="updateOrderItem($event, index)"
                    :valid-fields.sync="validOrderItem"
                    :valid-client-category-group.sync="validClientCategoryGroup"
                    :price-tables="priceTables"
                    :discount.sync="discount"
                    :order-discount.sync="order_discount"
                    :max-discount.sync="maxDiscount"
                    :campaigns="campaigns"
                    :product-validation-data="productValidationData"
                  />
                </div>
                <div class="col-md-12">
                  <base-button type="success" @click="addOrderItem"
                    >Adicionar Produtos</base-button
                  >
                </div>
              </div>
            </form>
          </validation-observer>
        </collapse-item>
      </collapse>
      <template slot="footer">
        <base-button type="secondary" class="mx-1" @click="modals.modal0 = false">Fechar</base-button>
        <div v-if="purchase_order && purchase_order.id" class="mx-2">
          <base-button class="mx-2" type="info" v-show="purchase_order.status_order === 'pending'" v-loading="isSaving" ref="budgetBtn" @click="handleSave(true)">Salvar Orçamento</base-button>
          <base-button type="success" v-loading="isSaving" ref="orderBtn" @click="handleSave(false)">Salvar Pedido</base-button>
        </div>
       <div v-else class="mx-1">
        <base-button  class="mx-2" type="info" v-loading="isSaving" ref="budgetBtn" @click="handleSave(true)">Salvar Orçamento</base-button>
        <base-button type="success" v-loading="isSaving" ref="orderBtn" @click="handleSave(false)">Salvar Pedido</base-button>
       </div>
      </template>
    </modal>

    <!-- Commercial Release Modal  -->
    <modal :show.sync="modals.modal1" id="confirmar-liberacao" size="lg">
      <template slot="header">
        <h2 id="exampleModalLabel">Confirmar Liberação Comercial</h2>
      </template>
      <base-input label="Usuários">
        <multiselect
          v-model="commercialReleaseUsers"
          :options="liberationUsers"
          placeholder="Selecionar Usuários"
          :select-label="''"
          :deselect-label="''"
          :selected-label="'Selecionado'"
          :required="true"
          label="name"
          track-by="id"
          @search-change="setLiberationUsers"
        />
      </base-input>

      <div>
        <div v-if="includesPendingValidations">
          <hr><h3>Detalhes</h3>
          <commercial-release-details :order-items="commercialDetailsOrders.order_items" :commercial-release="commercialDetailsOrders" :purchase-order="commercialDetailsOrders"/>
        </div>
      </div>
      <p style="font-size: 20px;"> <strong>Deseja efetuar a Liberação Comercial?</strong></p>
      <template slot="footer">
        <base-button type="secondary  " @click="modals.modal1 = false">Fechar</base-button>
        <base-button type="success" @click="sendCommercialRelease" v-loading="loadSendCommercial">Confirmar</base-button>
      </template>
    </modal>

    <!-- Filters -->
    <card>
      <div slot="header">
        <span>Pedidos</span>
      </div>
      <form>
        <div class="row">
          <div class="col-md-4">
            <base-input label="Cliente">
              <multiselect
                v-model="filter.client"
                :options="clients"
                placeholder="Selecionar Clientes"
                label="razao_social"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                track-by="id"
                :loading="isLoadingClient"
                :internal-search="false"
                @search-change="debouncedSetClients"
              >
                <template slot="option" slot-scope="props">
                  <div class="option__desc"><span class="option__title">{{ props.option.code }} - {{ props.option.razao_social }}</span></div>
                </template>
                <template slot="singleLabel" slot-scope="props">
                  <span class="multiselect__single">{{ props.option.code }}  {{ props.option.razao_social }}</span>
                </template>
              </multiselect>
            </base-input>
          </div>
          <div class="col-md-4">
            <base-input label="Status">
              <multiselect
                v-model="filter.status"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                :options="statuses"
                placeholder="Selecionar Status"
              />
            </base-input>
          </div>
          <div class="col-md-4">
            <base-input label="Código do Pedido">
              <multiselect
                v-model="filter.id"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                :options="codes"
                placeholder="Selecionar Código"
              />
            </base-input>
          </div>
          <div class="col-md-4">
            <base-input label="Código Empresa">
              <multiselect
                v-model="filter.codi_emp"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                :options="series"
                placeholder="Selecionar Código da Empresa"
              />
            </base-input>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label d-block">A partir de</label>
              <el-date-picker
                v-model="filter.startDate"
                type="date"
                placeholder="Data início"
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy"
                rules="required"
                :editable="true"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label d-block">Até</label>
              <el-date-picker
                v-model="filter.endDate"
                type="date"
                placeholder="Data Fim"
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy"
                rules="required"
                :editable="true"
              />
            </div>
          </div>
          <div class="col-md-2 pb-3">
            <div style="margin-top: 2rem;">
              <base-button
                icon
                type="primary"
                v-on:click="search"
              >
                <span class="btn-inner--icon">
                  <i class="fa fa-search"></i>
                </span>
                <span class="btn-inner--text">Pesquisar</span>
              </base-button>
            </div>
          </div>
        </div>
      </form>

      <!-- Purchase Order List -->
      <el-table
        v-loading="isLoading"
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        :data="purchase_orders"
        ref="purchase_orders"
      >
        <el-table-column label="" min-width="40px" v-slot="{ row }">
          <el-tooltip
            v-if="row.erp_error_message"
            placement="top"
          >
          <template #content>
            <div style="white-space: pre-line">{{ row.erp_error_message }}</div>
          </template>
            <i class="fa fa-exclamation-triangle alert-icon" style="color: #ffa348;"></i>
          </el-tooltip>
        </el-table-column>
        <el-table-column label="Código" min-width="120px"  prop="id" sortable />
        <el-table-column label="Código ERP" min-width="120px" prop="erp_code" sortable />
        <el-table-column label="Código Empresa" min-width="220px" prop="codi_emp" sortable/>
        <el-table-column label="Cliente" min-width="250px" v-slot="{ row }" sortable >
          {{ row.client.code + " - " + row.client.razao_social }}
        </el-table-column>
        <el-table-column label="Vendedor" min-width="220px" prop="user.name" sortable />
        <el-table-column label="Data Pedido" min-width="140" v-slot="{ row }" sortable>
          {{ row.created_at | humanDate }}
        </el-table-column>
        <el-table-column label="Situação" min-width="140px" v-slot="{ row }" sortable>
          <badge class="badge-dot">
            <i :class="row.human_status"></i>
          </badge>
          {{ row.human_status }}
        </el-table-column>
        <el-table-column label="Situação ERP" min-width="200px" v-slot="{ row }" sortable>
          <purchase-order-status :key="row.id" :purchase-order="row" />
        </el-table-column>
        <el-table-column label="Valor Total" min-width="150px" v-slot="{ row }" sortable>
          <span>{{
            row.total_cost.toLocaleString("pt-BR", {
              style: "currency",
              currency: "brl",
            })
          }}</span>
        </el-table-column>
        <el-table-column label="Ações" min-width="60" v-slot="{ row }">
          <div class="row">
            <el-dropdown
              trigger="hover"
              class="dropdown"
              style="cursor: pointer;"
            >
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu
                class="dropdown-menu dropdown-menu-arrow show"
                slot="dropdown"
              >
                <router-link
                  class="dropdown-item"
                  :to="{
                    name: 'order_items',
                    params: { purchase_order_id: row.id },
                  }"
                  >Produtos</router-link
                >
                <router-link
                  class="dropdown-item"
                  :to="{
                    name: 'invoice',
                    params: { purchase_order_id: row.id },
                  }"
                  >Extrato</router-link
                >
                <a class="dropdown-item" href="#" @click="remove(row)"
                  >Excluir</a
                >
                <a v-if="row.status_order == 'pending'" class="dropdown-item blue--text" href="#" @click="approveBudget(row)"
                  >Aprovar orçamento</a
                >
                <a v-if="row.status_order == 'pending'" class="dropdown-item red--text" href="#" @click="handleRejectOrder(row)"
                  >Recusar orçamento</a
                >
                <a class="dropdown-item" href="#" @click="isLoadingTable ? function() {return} : edit(row) ">
                  <div class="row">
                    <div class="col-md-12">
                      <span v-if="isLoadingTable">
                        <el-button
                          :loading="true"
                          type="text"
                          disabled
                        >
                          Editar
                        </el-button>
                      </span>
                      <span v-else>
                        Editar
                      </span>
                    </div>
                  </div>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
            <a @click="rowClicked(row)">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fa fa-eye mt-2"></i>
              </span>
            </a>
          </div>
        </el-table-column>
        <el-table-column type="expand">
          <template align="right" slot-scope="props">
            <div class="card-deck" style="white-space: normal;">
              <card>
                <h5 class="card-title">Descontos de Campanha</h5>
                <div
                  v-if="props.row.campaign_active_discounts"
                  class="tags-input__wrapper"
                >
                  <el-tag
                    v-for="(c_discount, index) in props.row.campaign_active_discounts"
                    :key="index"
                    size="mini"
                    effect="dark"
                    :closable="false"
                    class="tagproduto"
                    >Campanha: {{ c_discount }}</el-tag
                  >
                </div>
                <div v-else class="tags-input__wrapper">
                  <p>Nenhum Desconto</p>
                </div>

                <h5>
                  status:
                  <el-tag :type="formatPurchaseStatusOrder(props.row.status_order).color">
                    {{ formatPurchaseStatusOrder(props.row.status_order).text }}
                  </el-tag>
                </h5>
                <h5 v-if="props.row.status_order == 'rejected'">
                  Justificativa: {{ props.row.justification_budget_rejection }}

                </h5>
              </card>
              <card>
                <h5 class="card-title">Descontos Efetivos</h5>
                <div v-if="props.row.discount" class="tags-input__wrapper">
                  <el-tag
                    size="mini"
                    effect="dark"
                    :closable="false"
                    class="tagproduto"
                    >{{ props.row.discount.name }}</el-tag
                  >
                </div>
                <div v-else class="tags-input__wrapper">
                  <p>Nenhum Desconto</p>
                </div>

                <h5 class="card-title">Descontos dos Itens do Pedido</h5>
                <div v-if="props.row.order_items" class="tags-input__wrapper">
                  <el-tag
                    v-for="order_item in props.row.order_items"
                    :key="`order_item-${order_item.id}`"
                    size="mini"
                    effect="dark"
                    :closable="false"
                    class="tagproduto"
                    >{{ order_item.product_code + " - " + order_item.discount_percentage + "%" }}</el-tag
                  >
                </div>

              </card>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </card>
    <div slot="footer" class="py-4 d-flex justify-content-end">
      <base-pagination
        v-on:input="changePage"
        v-model="paginated_data['current']"
        :total="paginated_data['count']"
        :perPage="paginated_data['per_page']"
      ></base-pagination>
    </div>
    <modal :show.sync="rejectBudgetModal" id="anosafra">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Justifique sua recusa</h5>
      </template>
      <validation-observer ref="rejectFormObserver">
        <form role="form" @submit.prevent="rejectBudget">
          <div class="form-group">
            <label class="form-control-label">Justificativa</label><br>
            <multiselect
              v-model="approvalBudgetForm.rejection_category"
              :options="refusalJustifications"
              label="label"
              track-by="value"
              :allow-empty="false"
              :preserveSearch="true"
              placeholder="Selecionar Justificativa"
              :required="true"
            />
            <div
              class="invalid-feedback"
              v-show="rejectionCategoryErrorMessage"
              style="display: block;"
            >
              {{ rejectionCategoryErrorMessage }}
            </div>
            <label for="justification">Observação:</label>
            <textarea
              v-model="approvalBudgetForm.justification_budget_rejection"
              class="form-control"
              rows="3"
              minlength="20"
              maxlength="1000"
              placeholder="Descreva sua observação aqui"
              :required="true"
            ></textarea>
            <div
              class="invalid-feedback"
              v-show="rejectionJustificationErrorMessage"
              style="display: block;"
            >
              {{ rejectionJustificationErrorMessage }}
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="closeRejectBudgetModal">Fechar</base-button>
        <base-button type="success" @click="rejectBudget" :disabled="approvingBudget" v-loading="approvingBudget" >Salvar</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tag,
  Button,
  DatePicker,
} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import PurchaseOrderStatus from "../../components/PurchaseOrder/PurchaseOrderStatus.vue";
import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import { ValidationProvider, extend } from "vee-validate";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/l10n/pt.js";
import OrderItemForm from "@/views/PurchaseOrders/components/OrderItemForm";
import CommercialReleaseDetails from "./components/CommercialReleaseDetails.vue";
import { required } from "vee-validate/dist/rules";
import swal from "sweetalert2";


extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
  name: "purchase-order",
  components: {
    "el-table": Table,
    "el-button": Button,
    "el-table-column": TableColumn,
    PageTitle,
    Multiselect,
    ValidationProvider,
    flatPicker,
    "el-dropdown": Dropdown,
    "el-dropdown-item": DropdownItem,
    "el-dropdown-menu": DropdownMenu,
    "el-tag": Tag,
    Collapse,
    CollapseItem,
    OrderItemForm,
    CommercialReleaseDetails,
    OrderItemForm,
    [DatePicker.name]: DatePicker,
    PurchaseOrderStatus,
  },
  data() {
    return {
      rejectionCategoryErrorMessage: null,
      rejectionJustificationErrorMessage: null,
      refusalJustifications: [
        { value: 'condition', label: 'Condição Comercial' },
        { value: 'withdrawal', label: 'Desistência do Cliente' },
        { value: 'stock', label: 'Falta de Estoque' },
        { value: 'other', label: 'Outros' }
      ],
      debounceTimeout: null,
      commercialReleaseUsers: {},
      isLoadingClient: false,
      isLoadingEnterprise: false,
      isLoadingDiscount: false,
      isLoadingPayment: false,
      isLoadingProduct: false,
      isLoadingSalesman: false,
      isLoadingTable: false,
      isLoadingSalesmanErpValidation: false,
      isLoading: false,
      loadSendCommercial: false,
      modals: {
        modal0: false,
        modal1: false,
      },
      multipleActive: false,
      currentOrder: {
        commercial_release_attributes: {}
      },
      discount: 0,
      minimum_price: "",
      alreadyExist: false,
      c_active_index: 0,
      purchase_orders: [],
      client_price: [],
      purchase_order: {
        client: {
          client_properties: [],
        },
        client_property: {},
        client_info: {
          delivery_address: '',
          email: ''
        },
        order_items: [],
        payment_type: [],
        operation_type: [],
        payment_form: "",
        enterprises: {},
        issue_date: "",
        user: {},
        status_order: 0,
      },
      salesmans: [],
      product: {},
      product_price: {},
      filter: {
        client: null,
        enterprises: {},
        salesman: {},
        salesmans: [],
      },
      client: {
        client_properties: [],
      },
      commercialDetailsOrders: {},
      codes: [],
      fisico: 0,
      disponivel: 0,
      quantity: 0,
      errors: [],
      enterprises: [],
      users: [],
      clients: [],
      codi_emp: "",
      series: [],
      statuses: [],
      stocks: [],
      discounts: [],
      campaigns: [],
      payment_types: [],
      operation_types: [],
      filteredOperationTypes: [],
      filteredEnterprises: [],
      filteredPaymentTypes: [],
      formOfPayments: [
        { id: '01', condition: '1', description: 'Dinheiro'},
        { id: '02', condition: '1', description: 'Cartão de Crédito'},
        { id: '03', condition: '2', description: 'Duplicata'},
        { id: '04', condition: '1', description: 'Cheque'},
        { id: '05', condition: '1', description: 'Dinheiro / Cartão de Crédito'},
        { id: '06', condition: '1', description: 'Dinheiro / Cheque'},
        { id: '07', condition: '2', description: 'Dinheiro / Duplicata'},
        { id: '08', condition: '2', description: 'Cheque / Duplicata'},
        { id: '09', condition: '2', description: 'Carnê'},
        { id: '10', condition: '2', description: 'Boleto'},
        { id: '11', condition: '1', description: 'Cartão de Débito'},
        { id: '99', condition: '1', description: 'Outros'}
      ],
      // flag de verificação se foi pesquisado algo
      filtered: false,
      paginated_data: [],
      formData: {},
      expandedRow: {},
      status_classes: [
        "Registrado",
        "Esperando Aprovação",
        "Requisitada Alteração",
        "Aprovado",
        "Cancelado"
      ],
      priceTables: [],
      real_estates: [],
      products: [],
      validOrder: true,
      order_discount: 0,
      unit_value: null,
      maxDiscount: null,
      isSalesmansDisabled: false,
      cultures: [],
      notifyProductLiberationNeed: false,
      clientPurchaseValidations: {},
      salesmanPurchaseValidations: {},
      productValidationData: {},
      liberationUsers: [],
      liberationOrderItems: [],
      clientsTimeout: null,
      clientsLastSearch: null,
      validOrderItem: true,
      validClientCategoryGroup: true,
      clientProperty: null,
      isSaving: false,

      //Purchase Order Approval
      rejectBudgetModal: false,
      temporaryOrder:{},
      approvingBudget: false,
      approvalBudgetForm:{}
    };
  },
  created() {
    this.setData();
    this.setStaticData();
    this.setProductValidationData();
  },
  mounted() {
    if (this.$currentUser().is_admin) {
      this.setSalesmans("");
    } else if (this.$currentUser().is_manager || this.$currentUser().has_coordinateds) {
      this.salesmans = this.$currentUser().salesmans;
    }
    this.updateFilterClient();
    this.getEnterprises();
  },
  methods: {
    async getProductPrice(productId, priceTableId) {
      const params   = { q: { product_id: productId, price_table_id: priceTableId } }
      const response = await this.$http.secured.get("/api/v1/product_prices", { params: params })

      return response.data.product_prices[0]
    },
    handleOperationSelection() {
      if (this.purchase_order.operation_type) {
        this.purchase_order.operation_type_id = this.purchase_order.operation_type.codi_top
      } else {
        this.purchase_order.operation_type_id = null
      }

      this.filterPaymentType()
    },
    filterOperationType(query) {
      if (query == '') this.filteredOperationTypes = this.operation_types

      this.filteredOperationTypes = this.operation_types.filter((el) => {
        return el.desc_top.toUpperCase().includes(query.toUpperCase()) ||
          el.codi_top.toString().includes(query)
      })
    },
    filterEnterprises(query) {
      if (query == '') this.filteredEnterprises = this.enterprises

      if (query !== '') {
        this.filteredEnterprises = this.enterprises.filter((el) => {
          return el.iden_emp.toUpperCase().includes(query.toUpperCase()) ||
            el.codi_emp.toString().includes(query)
        })
      }
    },
    filterPaymentType(query = '') {
      this.filteredPaymentTypes = this.payment_types;

      if (query !== '') {
        this.filteredPaymentTypes = this.filteredPaymentTypes.filter((el) => {
          return el.name.toUpperCase().includes(query.toUpperCase()) ||
            el.code.toString().includes(query)
        })
      }

      const hasValidationData = this.productValidationData.condition_operation_validation_data.length > 0;
      const hasOperationType = this.purchase_order.operation_type !== undefined;

      if (hasValidationData && hasOperationType) {
        const isValidCondition = this.productValidationData.condition_operation_validation_data.some(el => {
          return el.operacao === this.purchase_order.operation_type.codi_top;
        });

        if (isValidCondition) {
          this.filteredPaymentTypes = this.filteredPaymentTypes.filter(el => {
            return this.productValidationData.condition_operation_validation_data.some(validationData => {
              return validationData.operacao === this.purchase_order.operation_type.codi_top &&
                validationData.condicao === el.code;
            });
          });
        }
      }
    },
    async setProductValidationData() {
      try {
        const response = await this.$http.secured.get("/api/v1/purchase_orders/product_validation_data")
        this.productValidationData = response.data;
      } catch (error) {
        console.warn("[PurchaseOrder] setProductValidationData", error);
      }
    },
    updateOrderItem(order_item, index) {
      this.$set(this.purchase_order.order_items, index, order_item)
    },
    updateValidOrderItem(value){
      this.validOrderItem = value
    },
    updateFilterClient() {
      let entryClient = this.$route.params.client;

      if (entryClient) this.filter.client = this.$route.params.client;
    },
    rowClicked(row) {
      if (this.expandedRow !== row) {
        this.$refs.purchase_orders.toggleRowExpansion(this.expandedRow);
        this.expandedRow = row;
      } else {
        this.expandedRow = null;
      }

      this.$refs.purchase_orders.toggleRowExpansion(row);
    },
    orderCollapsibleTitle() {
      // aquis
      if (!this.purchase_order && this.purchase_order.order_items.length) return "Dados do Pedido";

      let totalSum = this.purchase_order.order_items ? this.purchase_order.order_items.reduce(function (a, b) {
        if (!b.total_cost) return a + 0;

        return a + b.total_cost;
      }, 0) : 0

      return `Dados do Pedido Valor Total: R$ ${totalSum.toLocaleString(
        "pt-BR",
        { style: "currency", currency: "brl" }
      )}`;
    },
    collapsibleTitle(order_item, index) {
      if (order_item.product)
        return `Produto ${index + 1}: ${order_item.product.codi_psv} - ${order_item.product.desc_psv}`;

      return `Produto ${index + 1}`;
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    status_class(status) {
      return this.status_classes[status];
    },
    setProducts(description) {
      this.isLoading = true;
      let q = { description: description };
      if (typeof description === "undefined") q = null;

      this.$http.secured
        .get("/api/v1/products", {
          params: {
            q: q,
          },
        })
        .then((response) => {
          this.products = response.data["products"];
          this.isLoading = false;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    asyncProducts(query) {
      this.isLoadingProduct = true;
      this.setProducts(query);
    },
    setPriceTables() {
      this.isLoadingTable = true;

      this.$http.secured
        .get("/api/v1/price_tables")
        .then((response) => {
          this.priceTables = response.data.sort((a, b) => (a.code > b.code) ? 1 : -1);
          this.isLoadingTable = false;
        })
        .catch((error) => {
          this.setError(error, "Something went wrong");
          this.isLoadingTable = false;
        });
    },
    setData(page = null) {
      this.isLoading = true;

      //  Adicionando valores default a query e ao número da página se não definidos
      let q = {};
      if (typeof page === "undefined") page = null;
      if (typeof q === "undefined" || this.emptyFilter) q = null;
      this.filter.status
        ? (q.status = this.statuses.indexOf(this.filter.status))
        : null;
      this.filter.client ? (q.client_id = this.filter.client.id) : null;
      this.filter.code ? (q.id = this.filter.code) : null;
      this.filter.serie ? (q.codi_emp = this.filter.serie) : null;

      this.filter.startDate ? (q.start_date = this.filter.startDate) : null;
      this.filter.endDate ? (q.end_date = this.filter.endDate) : null;

      this.$http.secured
        .get("/api/v1/purchase_orders", {
          params: {
            page: page,
            q: q,
          },
        })
        .then((response) => {
          // setando dados de paginação e a collection produtos
          this.paginated_data = response.data;
          this.purchase_orders = response.data.purchase_orders;
          this.isLoading = false;
        })
        .catch((error) => {
          this.setError(error, "Something went wrong");
          this.isLoading = false;
        });
    },
    setStaticData() {
      if (this.$can("index", "client")) {
        this.setDiscounts();
        this.setCampaigns();
        this.setClients();
        this.setCodes();
        this.setPaymentTypes();
        this.setProducts();
        this.setPriceTables();
        this.setStatuses();
        this.setTypeOperations();
      }
    },
    initStocks() {
      this.$http.secured
        .get("/api/v1/report/stocks_data", {
          params: {
            codi_emp: this.purchase_order.enterprises ? this.purchase_order.enterprises.codi_emp : null,
            codi_psv: this.codi_psv ? this.codi_psv : null
          }
        })
        .then((response) => {
          this.stocks = response.data.stocks;
          this.isLoadingProduct = false;
        })
        .catch((error) => {
          this.setError(
            error,
            this.$toasted.global.defaultWarnig({ msg: "Não foram encontrados produtos deste fabricante"})
          );
          this.isLoadingProduct = false;
        });
    },
    getStock(order_item) {
      let sendStock = {};
      this.$http.secured
        .get("/api/v1/report/stocks_data", {
          params: {
            codi_emp: this.purchase_order.enterprises
              ? this.purchase_order.enterprises.codi_emp
              : null,
            codi_psv: order_item.product ? order_item.product.codi_psv : null,
          },
        })
        .then((response) => {
          let stock = response.data.stocks;
          order_item.product.disponivel = stock[0].disponivel;
          order_item.product.fisico = stock[0].fisico;
          order_item.product.tabe_ctas = stock[0].tabe_ctas;
          sendStock = {
            disponivel: order_item.product.disponivel,
            fisico: order_item.product.fisico,
          };
        })
        .catch((error) => {
          this.setError(
            error,
            this.$toasted.global.defaultWarnig({
              msg: "Não foram encontrados produtos deste fabricante",
            })
          );
        });
      return sendStock;
    },
    getProducts(q = "") {
      this.$http.secured
        .get("/api/v1/products", {
          params: { q: { description: q, status: "A" } },
        })
        .then((response) => {
          this.products = response.data["products"];
        })
        .catch((error) => this.setError(error, "failed to fetch products"));
    },
    getEnterprises(q = "") {
      this.isLoadingEnterprise = true;
      this.$http.secured
        .get("/api/v1/report/enterprise_data", {
          params: { q: { iden_emp: q, situ_emp: "A" } },
        })
        .then((response) => {
          this.isLoadingEnterprise = false;
          this.enterprises = response.data;
          this.enterprises.shift();
          this.enterprises.shift();
          this.enterprises.sort((a, b) => a.codi_emp - b.codi_emp);
          this.filteredEnterprises = response.data.sort((a, b) => a.codi_emp - b.codi_emp);
        })
        .catch((error) => {
          this.setError(
            error,
            this.$toasted.global.defaultWarnig({
              msg: "Empresas não encontradas",
            })
          );
          this.isLoadingEnterprise = false;
        });
    },
    search() {
      // // a flag filtered é verdadeira quando algo é pesqusado
      // // No caso se os campos de pesquisa estão vazios ela é falsa
      this.filtered = !this.emptyFilter;
      this.setData();
    },
    setCampaigns() {
      this.$http.secured
        .get("/api/v1/campaigns", {
          params: {
            unpaged: true,
            active: true,
          },
        })
        .then((response) => {
          this.campaigns = response.data;
        })
        .catch((error) => {
          this.setError(error, "failed to fetch campaigns");
        });
    },
    setTypeOperations() {
      this.$http.secured
        .get("/api/v1/operation_types")
        .then((response) => {
          this.operation_types = response.data;
          this.filteredOperationTypes = response.data;
          if (!Object.keys(this.purchase_order.operation_type).length) this.purchase_order.operation_type = this.defaultOperationType();
        })
        .catch((error) =>
          this.setError(error, "failed to fetch operation_types")
        );
    },
    setClientPrice() {
      this.$http.secured
        .get(`/api/v1/client_prices/${this.purchase_order.client.id}`)
        .then((response) => {
          const erpTable = response.data
          this.erpPriceTable = this.priceTables.find(function (price_table){
            return price_table.code = erpTable.tabe_cta
          })
        })
        .catch((error) =>
          this.setError(error, "failed to fetch operation_types")
        );
    },
    setStatuses() {
      this.$http.secured
        .get("/api/v1/purchase_orders", {
          params: {
            statuses_only: true,
          },
        })
        .then((response) => {
          this.statuses = response.data;
        })
        .catch((error) => this.setError(error, "failed to fetch campaigns"));
    },
    setCodes() {
      this.$http.secured
        .get("/api/v1/purchase_orders/index_codes")
        .then((response) => {
          this.orders = response.data
          this.codes = this.orders.map(order => order.id);
          this.orders.forEach(order => {
            if (order.codi_emp !== null && !this.series.includes(order.codi_emp)) {
              this.series.push(order.codi_emp);
            }
          });
        })
        .catch((error) => this.setError(error, "failed to fetch codes"));
    },
    setDiscounts() {
      this.isLoadingDiscounts = true;
      this.$http.secured
        .get("/api/v1/discounts", {
          params: {
            unpaged: true,
            q: { updated_at: true },
          },
        })
        .then((response) => {
          this.discounts = response.data;
          this.isLoadingDiscounts = false;
        })
        .catch((error) => {
          this.setError(error, "failed to fetch campaigns");
          this.isLoadingDiscounts = false;
        });
    },
    setPaymentTypes() {
      this.isLoadingPayment = true;
      this.$http.secured
        .get("/api/v1/payment_types", { params: { q: { category: 1 } } } )
        .then((response) => {
          this.payment_types = response.data.sort((a, b) => (a.code > b.code) ? 1 : -1);
          this.filteredPaymentTypes = this.payment_types;
          this.isLoadingPayment = false;
        })
        .catch((error) => {
          this.setError(error, "failed to fetch payment types");
          this.isLoadingPayment = false;
        });
    },
    changePayment(selectedPaymentTypes) {
      this.formOfPayments.forEach((el) => delete el.$isDisabled)
      let description = selectedPaymentTypes.name.toLowerCase();

      description = description.charAt(0).toUpperCase() + description.slice(1);

      this.formOfPayments.filter((el) => {
        if (
          selectedPaymentTypes.name.includes("DINHEIRO") &&
          el.description.includes("Cartão") ||
          selectedPaymentTypes.name.includes("CARTAO") &&
          el.description.includes("Dinheiro")
          ) {
          if (el.description == "Dinheiro / Cartão de Crédito") return;

          el.$isDisabled = true;
        }

      });
      if (!selectedPaymentTypes || selectedPaymentTypes.length === 0) {
        // Se nenhum tipo de pagamento for selecionado, não faz nada
        return;
      }
  
      if (selectedPaymentTypes.name.includes("VENDA A PRAZO")) {
        let days = 30; // Valor padrão para "VENDA A PRAZO 30 D"
        const regexResult = selectedPaymentTypes.name.match(/(\d+)/g); // Extrai os números da string
        regexResult && regexResult.length > 0 && regexResult.shift(); // Remove o primeiro número, que é o código do tipo de pagamento

        if (regexResult && regexResult.length > 0) {
          const numbers = regexResult.map(Number); // Converte os números de string para número
          const sum = numbers.reduce((a, b) => a + b, 0); // Soma os números
          days = sum/numbers.length; // Atualiza os dias com a soma dos números
        }

        const today = new Date();
        const dueDate = new Date(today.setDate(today.getDate() + days));

        // Atualiza a data de vencimento no modelo
        this.purchase_order.due_date = dueDate;
      }
    },
    debouncedSetClients(query){
      if (!query) return;
      if (this.clientsTimeout) clearTimeout(this.clientsTimeout);

      this.clientsTimeout = setTimeout(() => this.setClients(query), 500)
    },
    setClients(query) {
      const currentTimestamp = new Date().getTime();
      this.clientsLastSearch = currentTimestamp;

      this.isLoadingClient = true;

      var queryObj = null;
      if (typeof query != "undefined" && query != "") {
        queryObj = {
          fulltext: query,
        };
      }
      this.$http.secured
        .get("/api/v1/clients", {
          params: {
            q: queryObj,
          },
        })
        .then((response) => {
          if (this.clientsLastSearch != currentTimestamp) return;

          this.clients = response.data["clients"];
          this.real_estates = this.clientInfo.real_estates;
          this.isLoadingClient = false;
        })
        .catch((error) => {
          this.setError(error, "Something went wrong");
          this.isLoadingClient = false;
        });
    },
    setLiberationUsers(search = "") {
      let liberationDiscount =  Math.max(this.liberationOrderItems.map(function(oi) { return oi.discount_percentage}))
      var data = {
        q: {
          name: search,
          status: true,
          competence: liberationDiscount || 0
        },
      };
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.liberationUsers = response.data.users || [];
        })
        .catch((error) => this.setError(error, "failed to fetch users"));
    },
    setSalesmans(query) {
      this.isLoadingSalesman = true;
      const currentAnosafra = this.$store.state.currentAnosafra.id;
      var data = {
        per_page: 10,
        q: { 
           name: query,
           is_salesman: true,
           status: true,
           salesman_in_erp: true,
           anosafra_id: currentAnosafra 
        }
      }

      if (this.$currentUser().is_manager && !this.$currentUser().is_admin) {
        data.q.manager_id = this.$currentUser().id
      }

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.isLoadingSalesman = false;
          this.salesmans = response.data.users
        })
        .catch(() => (this.isLoadingSalesman = false))
    },
    async setClientSalesman() {
      if (!this.purchase_order.client.id) return;

      try {
        const clientId = this.purchase_order.client.id
        const codi_emp = this.purchase_order.enterprises ? this.purchase_order.enterprises.codi_emp : null;

        const response = await this.$http.secured.get(`/api/v1/clients/${clientId}/client_salesman`, {
          params: { codi_emp: codi_emp }
        });
        
        this.client_salesman = response.data;
        if (this.client_salesman.length === 0) {
          this.purchase_order.user = {};
          return;
        }

        this.purchase_order.user = {
          id: this.client_salesman[0].vendedor1,
          name: this.client_salesman[0].name
        };
      } catch(error){
        console.error("Erro ao buscar vendedor:", error);
      }
    },
    updateClientInfo() {
      if (!this.purchase_order.client) return;

      this.purchaseOrderClientInfo  = this.clientInfo;
      this.client.client_properties = this.clientInfo.client_properties;
      this.setClientPrice();
    },
    async validateClientForPurchase() {
      if (!this.purchase_order.client) {
        this.clientPurchaseValidations = {}
        return
      }

      const url      = `/api/v1/clients/${this.purchase_order.client.id}/purchase_validations`;
      const response = await this.$http.secured.get(url)

      this.clientPurchaseValidations = response.data
    },
    async validateErpSalesmanForPurchase(){
      this.salesmanPurchaseValidations.erpValidation = null

      if (!(this.purchase_order && this.purchase_order.user && this.purchase_order.user.id)) return;

      // Debounce validation
      const now = new Date()
      this.salesmanPurchaseValidations.lastExecution = now

      this.isLoadingSalesmanErpValidation = true
      try {
        const response = await this.$http.secured.get(`/api/v1/users/${this.purchase_order.user.id}/validate_erp_salesman`)

        // Debounce validation
        if (this.salesmanPurchaseValidations.lastExecution != now) return
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message){
          this.salesmanPurchaseValidations.erpValidation = error.response.data.message
        } else {
          this.salesmanPurchaseValidations.erpValidation = "Vendedor não encontrado no ERP"
        }
      }
      this.isLoadingSalesmanErpValidation = false;
      return !this.salesmanPurchaseValidations.erpValidation
    },
    async remove(purchase_order) {
      const fireResult = await swal.fire({
        title: 'Você tem certeza ?',
        text: "O pedido será excluído permanentemente!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, quero remover!'
      })

      if(!fireResult.isConfirmed) return;

      this.$http.secured
        .delete(`/api/v1/purchase_orders/${purchase_order.id}`, purchase_order)
        .then((response) => {
          this.$toasted.global.defaultSuccess();
          this.setData();
        })
        .catch((error) => {
          this.setError(error, "Cannot removepurchase_order");
          this.$refs.observer.setErrors(this.errors);
        });
    },
    changePage(page) {
      let filterInput = null;

      if (this.filtered) filterInput = this.filter;
      // Se algo foi pesquisado passa o parametro de filtro
      // Se não é passado parâmetro nulo
      this.setData(page);
    },
    openModalApprove(row) {
      this.modals.modal1 = true;
      this.currentOrder = row;
    },
    new() {
      this.resetPurchaseOrder()
      this.modals.modal0 = true;
    },
    async edit(purchase_order) {

      this.client.client_properties = purchase_order.client.client_properties;

      this.purchase_order = purchase_order;
      this.validateClientForPurchase();

      this.purchase_order.enterprises =
        this.enterprises.find(
          (enterprise) => enterprise.codi_emp === this.purchase_order.codi_emp
        ) || {};

      this.purchase_order.client.client_property = this.client.client_properties.find(
        (property) =>
          property.id === this.purchase_order.client_info.propried_id
      );

      this.purchase_order.client.client_property ? this.clientProperty = this.purchase_order.client.client_property : this.clientProperty = null

      this.purchase_order.operation_type = this.operation_types.find(
        (operation) =>
          operation.codi_top === this.purchase_order.operation_type_id
      );

      this.purchase_order.payment_type = this.payment_types.find(
        (payment) => payment.id === this.purchase_order.payment_type_id
      );

      this.purchase_order.payment_form = this.formOfPayments.find(
        (payment) => payment.id === this.purchase_order.payment_form_id
      );
      this.purchase_order.order_items.forEach(async (item) => {
        item.product.codi_psv = item.product_code;
        item.product.desc_psv = item.product.description;

        let getStock = this.getStock(item);
        let cultures = await this.getCultures(item.product.codi_psv)

        item.product.fisico = getStock.fisico ? getStock.fisico : 0;
        item.product.disponivel = getStock.disponivel ? getStock.disponivel : 0;

        item.price_table = this.priceTables.find(
          (price) => price.id === item.price_table_id
        );

        const product_price = await this.getProductPrice(
          item.product_id, item.price_table.id
        )

        item.product_price = product_price

        item.culture = cultures ? cultures.find((culture) => culture.codi_cul == item.cod_cul) : []

        item.enterprises = this.enterprises.find(
          (enterprise) => enterprise.codi_emp === item.codi_emp
        );
      });
      this.initStocks();
      this.purchase_order = Object.assign({}, this.purchase_order);
      this.modals.modal0 = true;
    },
    async sendCommercialRelease() {
      this.loadSendCommercial = true;

      if(!this.commercialReleaseUsers.id) {
        this.$toasted.global.defaultWarnig({
          msg: "Usuário não pode ficar em branco",
        });
        return
      }

      let data = {
        commercial_release: {
          author_id: this.$currentUser().id,
          salesman_id: this.currentOrder.user.id,
          status: 0,
          user_ids: [this.commercialReleaseUsers.id],
          purchase_order_id: this.currentOrder.id
        },
      };

      if (this.currentOrder.payment_method)
        data.commercial_release[
          "payment_type_id"
        ] = this.currentOrder.payment_type_id;
      if (this.currentOrder.total_cost)
        data.commercial_release["value"] = this.currentOrder.total_cost || 0;
      if (
        this.currentOrder.client_info &&
        this.currentOrder.client_info.client_id
      )
        data.commercial_release[
          "client_id"
        ] = this.currentOrder.client_info.client_id;

      if(this.currentOrder.commercial_release && this.currentOrder.commercial_release.id) {
        this.$http.secured
        .put(`/api/v1/commercial_releases/${this.currentOrder.commercial_release.id}`, data)
        .then((response) => {
          this.loadSendCommercial = false;
          this.modals.modal1 = false;
          this.$toasted.global.defaultSuccess({ msg: "Liberação Comercial editada com sucesso !!"});
        })
        .catch((error) => {
          this.setError(error, "Cannot save Sector");
        });
      } else {
        this.$http.secured
          .post(`/api/v1/commercial_releases`, data)
          .then((response) => {
            this.loadSendCommercial = false;
            this.modals.modal1 = false;
            this.$toasted.global.defaultSuccess({ msg: "Liberação Comercial criada com sucesso !!"});
            this.currentOrder.commercial_release = {
              id: response.data.id
            }
          })
          .catch((error) => {
            this.setError(error, "Cannot save Sector");
          });
        }
      this.alreadyExist = false;
    },
    async handleSave(isBudget) {
      if (this.isSaving) return;


      this.isSaving = true;
      isBudget ? await this.saveBudget() : await this.save();
      this.isSaving = false;
    },
    async saveBudget(){
      const isValid = await this.saveValidations();
      if(!isValid) return;

      this.purchase_order.status_order = "pending"

      this.currentOrder = {
        value:  this.reqParams,
        client_info: {
          client_id: this.reqParams.data.purchase_order.client_info_attributes
          .client_id,
        },
        total_cost: this.reqParams.data.purchase_order.order_items_attributes[0] ?
          this.reqParams.data.purchase_order.order_items_attributes[0].total_cost :
          0,
        user_id: this.$currentUser().id,
      };

      try {
        const response = await this.$http.secured(this.reqParams)
        this.commercialDetailsOrders = response.data;
        if (response.data && response.data.need_liberation) {
          this.openModalApprove(this.currentOrder);
        }

        this.$toasted.global.defaultSuccess();
        this.setData();
        this.modals.modal0 = false;
        this.resetInputs();
        this.setClients();
        this.$refs.observer.reset();
        this.currentOrder = response.data;
       ;

      } catch(error) {
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors[0]
          ? this.$toasted.global.defaultWarnig({
              msg: error.response.data.errors[0],
            })
          : this.$toasted.global.defaultError({
              msg: "Não foi possível cadastrar o pedido !",
            });
        this.setError('ERRO: ',error)
        this.$refs.observer.setErrors(this.errors);
      }
    },
    async save() {
      const isValid = await this.saveValidations();
      if(!isValid) return;

      this.currentOrder = {
        value: this.reqParams,
        client_info: {
          client_id: this.reqParams.data.purchase_order.client_info_attributes
            .client_id,
        },
        total_cost: this.reqParams.data.purchase_order.order_items_attributes[0] ?
          this.reqParams.data.purchase_order.order_items_attributes[0].total_cost :
          0,
        user_id: this.$currentUser().id,
        status: 1,
        status_order:0
      };

      try {
        const response = await this.$http.secured(this.reqParams)
        this.commercialDetailsOrders = response.data;
        if (response.data && response.data.need_liberation) {
          this.openModalApprove(this.currentOrder);
        }

        this.$toasted.global.defaultSuccess();
        this.setData();
        this.modals.modal0 = false;
        this.resetInputs();
        this.setClients();
        this.$refs.observer.reset();
        this.currentOrder = response.data;

      } catch(error) {
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors[0]
          ? this.$toasted.global.defaultWarnig({
              msg: error.response.data.errors[0],
            })
          : this.$toasted.global.defaultError({
              msg: "Não foi possível cadastrar o pedido !",
            });
        this.setError(error, "Something went wrong");
        this.$refs.observer.setErrors(this.errors);
      }
    },
    async saveValidations(){
      if (this.purchase_order.order_items) this.liberationOrderItems = this.purchase_order.order_items;

      this.setLiberationUsers();

      if (!this.validClientCategoryGroup) {
        this.$toasted.global.defaultWarnig({
          msg: "Cliente sem autorização de compra de defensivos!"
        });
        return false;
      }

      if (!this.validPurchasOrder() || !this.validOrder || !this.validOrderItem) {
        this.$toasted.global.defaultWarnig({ msg: "Necessário preencher campos obrigatórios"});
        return false;
      }

      if (!this.purchase_order.order_items || this.purchase_order.order_items.length == 0) {
        this.$toasted.global.defaultWarnig({ msg: "Necessário adicionar itens ao pedido"});
        return false;
      }

      if (!this.validateCampaign()) {
        this.$toasted.global.defaultWarnig({
          msg: "Pedido precisa conter produto da campanha",
        });
        return false
      }

      if (this.isLoadingSalesmanErpValidation) {
        this.$toasted.global.defaultWarnig({
          msg: "Aguarde a validação do vendedor no ERP",
        });
        return false
      }

      if (typeof this.salesmanPurchaseValidations.erpValidation == "string") {
        this.$toasted.global.defaultWarnig({
          msg: "Vendedor não consta ou não está ativo no ERP",
        });
        return false
      }

      if (!this.authorizedSalemanForClient()) {
        this.unauthorizedSalesmanMessage();
      }

      if (this.clientPurchaseValidations.over_credit_limit == true && this.clientPurchaseValidations.overdue_account == false) {
        this.overdueCreditLimitMessage()
      }

      if (this.clientPurchaseValidations.over_credit_limit == false && this.clientPurchaseValidations.overdue_account == true) {
        this.overdueAccountMessage()
      }

      if ((this.clientPurchaseValidations.over_credit_limit == true && this.clientPurchaseValidations.overdue_account == true) && !this.purchase_order.payment_type.name.includes('VISTA')) {
        let swalResult = await swal.fire({
          title: `Deseja continuar?`,
          text: 'O cliente possui contas vencidas ou ultrapassou o limite de crédito, será necessária liberação financeira no Siagri!',
          buttonsStyling: false,
          icon: 'info',
          showCancelButton: true,
          cancelButtonClass: 'btn btn-warning',
          cancelButtonText: "Fechar",
          confirmButtonClass: 'btn btn-success mr-2',
          confirmButtonText: 'Continuar'
        })

        if (swalResult.isDismissed) return false;
      }

      return true
    },
    resetProperty() {
      this.clientProperty = null
    },
    resetInputs() {
      this.filter = {};
      this.resetPurchaseOrder();
    },
    resetPurchaseOrder() {
      this.purchase_order = {
        client: {},
        client_info: {},
        order_items: [],
        user: this.$currentUser(),
        operation_type: this.defaultOperationType(),
        payment_type: this.defaultPaymentType(),
        payment_form: this.defaultPaymentForm()
      };

      this.purchase_order.operation_type_id = this.purchase_order.operation_type.codi_top
    },
    defaultOperationType(){
      return this.operation_types.find((el) => el.codi_top == 20) || {}
    },
    defaultPaymentForm() {
      return this.formOfPayments.find((el) => el.description == "Dinheiro")
    },
    defaultPaymentType(){
      return this.payment_types.find((el) => el.code == 102) || {}
    },
    setIssueDate() {
      this.purchase_order.issue_date = new Date()
      this.purchase_order.due_date = new Date()
    },
    async unauthorizedSalesmanMessage() {
      let swalResult = await swal.fire({
        title: `Liberação Comercial`,
        text: 'Vendedor Informado diferente do configurado no parceiro/propriedade. Será necessária a liberação comercial!',
        buttonsStyling: false,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonClass: 'btn',
        confirmButtonText: 'Fechar'
      })

      if (swalResult.isDismissed) return;
    },
    async overdueAccountMessage() {
      let swalResult = await swal.fire({
        title: `Deseja continuar?`,
        text: 'O cliente possui contas vencidas, será necessária liberação financeira no Siagri!',
        buttonsStyling: false,
        icon: 'info',
        showCancelButton: true,
        cancelButtonClass: 'btn btn-warning',
        cancelButtonText: "Fechar",
        confirmButtonClass: 'btn btn-success mr-2',
        confirmButtonText: 'Continuar'
      })

      if (swalResult.isDismissed) return;

    },
    async overdueCreditLimitMessage() {
      let swalResult = await swal.fire({
        title: `Deseja continuar?`,
        text: 'O cliente ultrapassou o limite de crédito, será necessária liberação financeira no Siagri!',
        buttonsStyling: false,
        icon: 'info',
        showCancelButton: true,
        cancelButtonClass: 'btn btn-warning',
        cancelButtonText: "Fechar",
        confirmButtonClass: 'btn btn-success mr-2',
        confirmButtonText: 'Continuar'
      })

      if (swalResult.isDismissed) return;
    },
    register() {
      this.filter = {};
      this.resetPurchaseOrder();

      // this.isSalesmansDisabled = true;
      this.setIssueDate();
      this.modals.modal0 = true;
    },
    validPurchasOrder() {
      this.validOrder = true;

      let requiredAttributes = [
        "client",
        "due_date",
        "payment_type",
        "enterprises",
        "operation_type",
        "payment_form",
        ["client_info", "delivery_address"],
      ];

      for (let i = 0; i < requiredAttributes.length; i++) {
        var attr = requiredAttributes[i];
        var evaluatedValue = null;

        if (Array.isArray(attr)) {
          evaluatedValue = this.purchase_order[attr[0]] && this.purchase_order[attr[0]][attr[1]];
        } else {
          evaluatedValue = this.purchase_order[attr];
        }

        if (
          (evaluatedValue === undefined) ||
          (evaluatedValue === null) ||
          (typeof evaluatedValue == "object" &&
          !Object.keys(evaluatedValue).length)
        ) {
          this.validOrder = false;
          return false;
        }
      }

      if ((!this.clientProperty || JSON.stringify(this.clientProperty) === "{}") && (this.client.client_properties.length || !this.purchase_order.client_info.delivery_address)) {
        this.validOrder = false;
        return false
      }

      return true;
    },
    authorizedSalemanForClient(){
      if (this.clientPurchaseValidations.authorized_salesmen.length == 0) return true;
      if (!this.purchase_order.enterprises || !this.purchase_order.user)  return true;

      let authorizedSalesman = this.clientPurchaseValidations.authorized_salesmen.find(
        el => (
          el['empresa']   == this.purchase_order.enterprises.codi_emp &&
          el['vendedor1'] == this.purchase_order.user.id
        )
      )

      if (authorizedSalesman) return true;

      return false;
    },
    validField(value) {
      if (typeof value == "object" && value) {
        if (this.validOrder == false && Object.keys(value).length == 0)
          return false;
      }

      if (this.validOrder == false && !value) return false;

      return true;
    },
    validateCampaign() {
      if (
        this.purchase_order.campaign &&
        this.purchase_order.campaign.preferredproduct &&
        this.purchase_order.campaign.preferredproduct.product_ids.length &&
        !this.purchase_order.order_items.filter((n) => {
          return (
            this.purchase_order.campaign.preferredproduct.product_ids.indexOf(
              n.product.id
            ) !== -1
          );
        }).length
      ) {
        return false;
      }

      return true;
    },
    validBeforeAddOrderItem() {
      if (this.purchase_order.order_items.length == 0) return true;

      this.purchase_order.order_items.map(order_item => {
        if (!order_item.unit_value) {
          this.$toasted.global.defaultWarnig({msg: "Finalize antes de adicionar mais produtos."})
          return false
        }
      })

      return true;
    },
    addOrderItem() {
      // this.validateClientForPurchase();
      if (!this.validPurchasOrder()) return;
      if (!this.validBeforeAddOrderItem()) return;

      if (new Date(this.purchase_order.issue_date) > new Date(this.purchase_order.due_date)) {
        this.$toasted.global.defaultWarnig({ msg: "Data de vencimento não pode ser menor que a data de emissão" });
        return;
      }
      this.purchase_order.order_items.push({
        delivery_date: new Date(),
      });
    },
    async getCultures(codi_psv) {
      let response  = await this.$http.secured.get("/api/v1/report/cultures_data", {params: { codi_psv: codi_psv }})
                                .catch((error) => this.setError(error, "Something went wrong"));
        this.cultures = response.data.prod_cultures
        return this.cultures
    },
    initClientInfo(purchaseOrder, value = null ) {
      purchaseOrder.client_info = value ? value : {}
    },
    removeOrderItem(index) {
      this.purchase_order.order_items.splice(index, 1);
    },
    formatPurchaseStatusOrder(status){
      switch (status) {
        case 'deferred':
          return { color: 'success', text: 'Aprovado'}
        case 'rejected':
          return { color: 'danger', text: 'Recusado'}
        case 'pending':
          return { color: '', text: 'Pendente'}
        default:
          return { color: '', text: 'Aguardando Liberação'}
      }
    },
    validateRejectionJustification() {
      if (!this.approvalBudgetForm.justification_budget_rejection) {
        this.rejectionJustificationErrorMessage = 'Campo Obrigatório'
        return false
      }

      if (this.approvalBudgetForm.justification_budget_rejection.length < 20) {
        this.rejectionJustificationErrorMessage = 'Precisa ter no mínimo 20 caracteres'
        return false
      }

      if (this.approvalBudgetForm.justification_budget_rejection.length > 1000) {
        this.rejectionJustificationErrorMessage = 'Precisa ter no máximo 1000 caracteres'
        return false
      }

      this.rejectionJustificationErrorMessage = null
      return true
    },
    validateRejectionCategory() {
      if (!this.approvalBudgetForm.rejection_category) {
        this.rejectionCategoryErrorMessage = 'Campo Obrigatório'
        return false
      }

      this.rejectionCategoryErrorMessage = null
      return true
    },
    async rejectBudget(){
      const validForm = this.validateRejectionJustification() && this.validateRejectionCategory()

      if (!validForm) return;

      let data = {
        purchase_order: {
          status_order: 'rejected',
          justification_budget_rejection: this.approvalBudgetForm.justification_budget_rejection,
          rejection_category: this.approvalBudgetForm.rejection_category.value
        }
      }

      try {
        await this.$http.secured
        .put(`api/v1/purchase_orders/${this.temporaryOrder.id}`, data)

        this.temporaryOrder = {}
        this.$toasted.global.defaultSuccess({ msg: "O orçamento foi reprovado com sucesso!"})

        this.rejectBudgetModal = false
        this.setData()

      } catch (error) {
        this.temporaryOrder = {}
        this.rejectBudgetModal = false
        console.log('Error :', error)
      } finally {
        this.approvalBudgetForm.justification_budget_rejection = null
        this.approvalBudgetForm.rejection_category = null
      }
    },
    handleRejectOrder(order){
      this.temporaryOrder = order
      this.rejectBudgetModal = true
    },
    closeRejectBudgetModal(){
      this.rejectBudgetModal = false
      this.temporaryOrder = {}
    },
    async approveBudget(order){
      let data = {
        purchase_order: {
          status_order: 'deferred'
        }
      }

      try {
        await this.$http.secured
        .put(`api/v1/purchase_orders/${order.id}`, data)
        this.temporaryOrder = {}
        this.$toasted.global.defaultSuccess({ msg: "Orçamento aprovado com sucesso" });
        this.setData()


      } catch (error) {
        this.temporaryOrder = {}
        console.log('Error :', error)
      }
    },
  },
  computed: {
    filteredClientProperties() {
      return this.client.client_properties.filter(property => property.situacao === true);
    },
    purchaseOrderClient: {
      set: function(val) {
        this.purchase_order.client = val;
      },
      get: function() {
        return this.purchase_order.client ? this.purchase_order.client : { client_properties: [] };
      }
    },
    purchaseOrderClientInfo: {
      set: function(val) {
        this.purchase_order.client_info = val;
      },
      get: function() {
        return this.purchase_order.client_info ? this.purchase_order.client_info : { email: '', delivery_address: '' };
      }
    },
    filteredFormOfPayments () {
      const condition = this.purchase_order && this.purchase_order.payment_type && this.purchase_order.payment_type.condition
      if (!(condition && ['1', '2'].includes(condition.toString()))) return this.formOfPayments

      return this.formOfPayments.filter(f => f.condition == condition)
    },
    price_table: {
      set(orderItem, priceTable) {
        orderItem.price_table = priceTable;
      },
      get(orderItem) {
        return orderItem.price_table || this.erpPriceTable;
      },
    },
    reqParams: function () {
      if (this.purchase_order.hasOwnProperty("id")) {
        return {
          url: `/api/v1/purchase_orders/${this.purchase_order.id}`,
          method: "patch",
          data: { purchase_order: this.nomalizedOrder},
        };
      }

      return {
        url: "/api/v1/purchase_orders",
        method: "post",
        data: { purchase_order: this.nomalizedOrder },
      };
    },
    emptyFilter: function () {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    nomalizedOrder: function () {
      let purchase_order_computed = this.purchase_order;

      if (purchase_order_computed.enterprises)
        purchase_order_computed.codi_emp = purchase_order_computed.enterprises.codi_emp;

      for (let key in purchase_order_computed) {
        // replacing objects by ids
        if (purchase_order_computed[key] === undefined || purchase_order_computed[key] === null) {
          delete purchase_order_computed[key];
        }

        if (purchase_order_computed.hasOwnProperty(key) && key == "status")
          delete purchase_order_computed[key];

        if (
          purchase_order_computed.hasOwnProperty(key) &&
          typeof purchase_order_computed[key] == "object" &&
          key == "client_info"
        ) {
          purchase_order_computed["client_info_attributes"] = purchase_order_computed[key];
          delete purchase_order_computed[key];
        }

        if (
          purchase_order_computed.hasOwnProperty(key) &&
          typeof purchase_order_computed[key] == "object" &&
          purchase_order_computed[key].hasOwnProperty("id")
        ) {
          purchase_order_computed[key + "_id"] = purchase_order_computed[key].id;
          delete purchase_order_computed[key];
        }

        if (purchase_order_computed.hasOwnProperty(key) && key == "order_items") {
          let items = purchase_order_computed[key];
          for (let item of items) {
            item.cod_cul = item.culture ? item.culture.codi_cul : ''
            for (let inner_key in item) {
              if (
                item.hasOwnProperty(inner_key) &&
                item[inner_key] &&
                typeof item[inner_key] == "object" &&
                item[inner_key].hasOwnProperty("id")
              ) {
                item[inner_key + "_id"] = item[inner_key].id;
                delete item[inner_key];
              }
            }
          }

          purchase_order_computed["order_items_attributes"] = items;
          delete purchase_order_computed[key];
        }
      }
      return purchase_order_computed;
    },
    clientInfo: function () {
      return {
        email: this.purchase_order && this.purchase_order.client && this.purchase_order.client.email,
        delivery_address: this.purchase_order && this.purchase_order.client.endereco,
        client_id: this.purchase_order.client.id,
        client: this.purchase_order.client,
        real_estates: this.purchase_order.client.real_estates,
        client_properties: this.purchase_order && this.purchase_order.client.client_properties,
      };
    },
    includesPendingValidations() {
      const verifyPendingValidations = this.commercialDetailsOrders.pending_validations;
      return (
        Array.isArray(verifyPendingValidations) &&
        (verifyPendingValidations.includes('unit_value') || verifyPendingValidations.includes('max_discount'))
      );
    },
  },
  watch: {
    "purchase_order.client.id"(newClientId) {
      if (newClientId && this.purchase_order.enterprises) {
        this.setClientSalesman();
      }
    },
    "purchase_order.order_items": function (v) {
      setTimeout(() => (this.c_active_index = v), 50);
    },
    "purchase_order.user": function (value) {
      if (!(value && value.id)) return

      if(this.debounceTimeout){
        clearTimeout(this.debounceTimeout)
      }

      this.debounceTimeout = setTimeout(() => {
        this.validateErpSalesmanForPurchase()
      }, 500)
    },
    validOrderItem(value) {
      console.log("validOrderItem: ", value)
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.swal2-html-container {
  font-size: 1.2rem !important;
}
button:disabled,
button[disabled]{
  cursor: not-allowed !important;
}
</style>
